import request from '../../../../../services/axios';
import {IBankAccountInfo} from '../getBankAccountInfo/getBankAccountInfo';

export const patchBankAccountInfo = async (payload: IBankAccountInfo) => {
  const {guid, ...apiPayload} = payload;

  const {data} = await request.patch(
    `/api/v2/payment/cashback/bank-info/${guid}`,
    apiPayload,
  );

  return data;
};
